import React, { PropTypes } from 'react'
import CSSModules from 'react-css-modules'

import styles from './contact-us-modal.css'

const ContactUsModal = ({ market }) => (
  <div styleName="content">
    <p>For any questions please contact Time Out Customer Care below:</p>

    {market &&
      <div>
        <ul styleName="list">
          { market.tradedeskEmail &&
            <li>
              Email: <a href={market.tradedeskEmail} styleName="link">{market.tradedeskEmail}</a>
            </li>
          }
          { market.tradedeskPhone &&
            <li>Phone: {market.tradedeskPhone}</li>
          }
        </ul>
      </div>
    }

  </div>
)

ContactUsModal.propTypes = {
  market: PropTypes.object,
}

export default CSSModules(ContactUsModal, styles)



/** WEBPACK FOOTER **
 ** ./src/components/contact-us-modal/contact-us-modal.js
 **/